// extracted by mini-css-extract-plugin
export var linkBox = "component-module--linkBox--9f39a";